import React from "react";

interface IStyleProps {
  fillColor?: string;
}

const EditTextIcon: React.FC<IStyleProps> = (props) => {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 0V5.86H3.6V3.8H7.2V15.2H4.98316V19H13.0168V15.2H10.8V3.8H14.4V5.86H18V0H0Z"
        fill={props.fillColor ?? "black"}
      />
    </svg>
  );
}

export default EditTextIcon;